import { render } from "./MenuContent.vue?vue&type=template&id=eb1555e8&scoped=true&ts=true"
import script from "./MenuContent.vue?vue&type=script&lang=ts"
export * from "./MenuContent.vue?vue&type=script&lang=ts"

import "./MenuContent.vue?vue&type=style&index=0&id=eb1555e8&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb1555e8"]])

export default __exports__